export const appVersion = 'manage-v2@v2026.11.01.2309-820e5005';
